import tw from 'twin.macro';

const QuestionTitleSkeleton = tw.div`h-8 w-full rounded-md bg-slate-200`;

const QuestionDetailsSkeleton: React.FC = () => {
  return (
    <div tw="flex h-fit animate-pulse flex-col items-center gap-6 rounded-lg bg-white py-6 px-6 sm:(py-12 h-[184px])">
      <p tw="select-none whitespace-nowrap rounded-full bg-slate-200 px-4 py-1 font-medium text-slate-200">
        คำถามข้อที่ -
      </p>
      <QuestionTitleSkeleton />
    </div>
  );
};

export default QuestionDetailsSkeleton;
